import React from 'react';
import * as Yup from 'yup';

import { ApplicationFlow } from '../components';
import { documentTypes } from '../data';


const Description = () => (
  <React.Fragment>
    <p>
     To clarify the federal government's definitions of a churches and other religious institution, the Internal Revenue Service uses clearly-defined guidelines. Over the years, the IRS has revised this list in response to various court decisions. To define churches and other religious entities, some of the IRS guidelines consider whether or not an institution has:
    </p>
    <ul>
      <li>A distinct legal existence and religious history,</li>
      <li>A recognized creed and form of worship,</li>
      <li>
        Established places of worship
      </li>
      <li>
        A regular congregation and regular religious services, and
      </li>
      <li>
        an organization of ordained ministers
      </li>
    </ul>
    <p>
    Most mainstream religions such as Catholicism, Judaism, and common Protestant sects fit easily within the IRS guidelines. However, churches that are less traditional sometimes face difficulty in meeting the federal government's definition.
    </p>
  </React.Fragment>
);


const fieldSets = [
  {
    legend: 'Church Organization Information',
    fields: new Map([
      ['orgName',{
        label : 'Church Name',
      }],
      ['dba', {
        'data-help-text': 'Please enter the trade name of the organization.',
      }],
    ]),
  },
  {
    legend: 'Responsible Party Information',
    fields: new Map([
      ['firstName', {
        'data-help-title': 'Responsible Party',
        'data-help-text': 'A Responsible Party is a person who has a level of control over or entitlement to the funds or assets of an entity.',
      }],
      ['middleName', {
        'data-help-title': 'Responsible Party',
        'data-help-text': 'A Responsible Party is a person who has a level of control over or entitlement to the funds or assets of an entity.',
      }],
      ['lastName', {
        'data-help-title': 'Responsible Party',
        'data-help-text': 'A Responsible Party is a person who has a level of control over or entitlement to the funds or assets of an entity.',
      }],
      ['socialSecurity', {
        'data-help-title': 'Responsible Party',
        'data-help-text': 'A Responsible Party is a person who has a level of control over or entitlement to the funds or assets of an entity.',
      }],
      ['verifySocialSecurity', {
        'data-help-title': 'Responsible Party',
        'data-help-text': 'A Responsible Party is a person who has a level of control over or entitlement to the funds or assets of an entity.',
      }],
      ['title', {
        label: "Officer's Title",
        placeholder: 'Mangaing Member',
        'data-help-title': 'Mangaing Member',
        'data-help-text': 'A Mangaing Member is a person who has a level of control over or entitlement to the funds or assets of an entity.',
      }],
      ['suffix', {
        initial: 'MD',
      }],
    ]),
  },
  {
    legend: 'Business Address (No PO Boxes)',
    fields: new Map([
      ['businessAddress'],
      ['businessCity'],
      ['businessState'],
      ['businessZip'],
      ['businessCounty'],
      ['mailingAddressDiff'],
    ]),
  },
  {
    legend: 'Business Information',
    fields: new Map([
      ['businessIncCountry',{
        label: 'Where was the Corporation organized?'
      }],
      ['businessApplyReason'],
      ['businessActivity'],
      ['businessServices'],
      ['commonQuestionOne'],
      ['commonQuestionTwo'],
      ['commonQuestionThree'],
      ['commonQuestionFour'],
      ['businessAppliedBefore'],
      ['businessHireEmployees'],
    ]),
  },
  {
    legend: 'Business Dates',
    fields: new Map([
      ['businessDateStart'],
      ['businessClosingMonth'],
    ]),
  },
  {
    legend: 'Contact Information',
    fields: new Map([
      ['customerContactPhone'],
      ['customerContactEmail'],
      ['customerContactEmailVerify',{
        label: 'Verify Contact E-mail'
      }],
    ]),
  },
];


const ChurchOrganizationApplicationPage = props => (
  <ApplicationFlow
    step={2}
    title="Church Organization Application"
    documentType={documentTypes.CHURCH_CONTROLLED_ORGANIZATION}
    description={Description}
    fieldSets={fieldSets}
    {...props}
  />
);

export default ChurchOrganizationApplicationPage;



// WEBPACK FOOTER //
// ./src/pages/church-organization-application.js